import { t } from '../../i18n';

/** Languages prompts are recorded in, by ISO 639-1 code. */
export const languageNames: Record<string, string> = {
  lt: t('Lithuanian'),
  en: t('English'),
  ru: t('Russian'),
  pl: t('Polish'),
  lv: t('Latvian'),
  et: t('Estonian'),
  de: t('German'),
  fi: t('Finnish'),
  uk: t('Ukrainian'),
};
